<template>
  <div class="hot__sale">
    <div class="hot__sale__title">
      <img class="logo" src="@/assets/store/hot-sale.png" />
      <el-button @click="$emit('click-more')" plain class="hot__sale__title__more">
        查看更多
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
    <div class="hot__sale__list">
      <GoodsInfo
        mini
        class="pointer"
        v-for="goods in goodsList"
        :key="goods.itemCode"
        :goods="goods"
        :itemStyle="itemStyle"
        :hideIcon="false"
        @update-cart="$emit('update-cart')"
        :imgStyle="imgStyle"
        itemType="store"
        :purchaseAble="true"
        @click-goods="linkToGoodsDetails(goods.itemCode)"
      />
    </div>
  </div>
</template>

<script>
import GoodsInfo from '@/components/GoodsInfo';
export default {
  props: {
    goodsList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    GoodsInfo
  },
  data() {
    return {
      itemStyle: {
        width: '219px',
        border: '1px solid #D9D9D9',
        margin: '0 8px 16px 8px',
        marginBottom: '16px'
      },
      imgStyle: {
        width: '195px',
        height: '195px'
      }
    };
  },
  methods: {
    linkToGoodsDetails(id) {
      this.$router.push({ path: `/goodsDetails/${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.hot__sale {
  margin-top: 16px;
  padding: 32px 28px;
  background-color: #ffffff;
  .logo {
    width: 320px;
    height: 32px;
  }
  &__title {
    position: relative;
    text-align: center;
    &__more {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 14px;
      font-weight: 400;
      padding-right: 0;
      color: #595959;
      line-height: 1;
      border: none;
    }
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
    ::v-deep .drug__item + .drug__item {
      margin-left: 16px;
    }
    ::v-deep .drug__item:nth-child(5n + 1) {
      margin-left: 0;
    }
  }
}
</style>
